<script lang="ts" setup>
import { ref } from "vue";
import { goDiscordLink } from "@/use/go";
import { ThreadsNavInstance } from "@/components/mobile/ThreadsNav.vue";
import { useI18n } from "vue-i18n";
import { useUI } from "@/stores/ui";

const { t } = useI18n();
const uiStore = useUI();
</script>
<template>
  <div class="grid grid-rows-[auto_1fr] h-full overflow-hidden">
    <ThreadsNav show-back>
      <template #center>
        <div class="font-bold text-base">{{ $t("contactUs.contactUs") }}</div>
      </template>
    </ThreadsNav>
    <div class="p-4 flex flex-col gap-8">
      <a class="flex items-center justify-center" href="/">
        <LogoIcon class="w-40" />
      </a>
      <div class="text-2xl font-bold text-center">
        {{ $t("contactUs.needHelp") }}
      </div>
      <div class="flex flex-col gap-4">
        <div class="text-xl font-bold">
          {{ $t("contactUs.joinCommunity") }}
        </div>
        <div class="grid grid-cols-2 gap-4">
          <button class="btn" @click="goDiscordLink">
            <i class="iconfont icon-discord1 text-2xl"></i>
            <span class="flex text-lg">Discord</span>
          </button>
          <button class="btn" @click="uiStore.showWechatDialog = true">
            <i class="iconfont icon-wechat-fill text-[1.8rem]" />
            <span class="flex text-lg">{{ $t("SidebarNavi.wechat") }}</span>
          </button>
        </div>
      </div>
      <div class="flex flex-col gap-4">
        <div class="text-xl font-bold">{{ $t("contactUs.emailUs") }}</div>
        <div class="prose prose-sm md:prose-base">
          <ul>
            <li>
              <a
                class="text-base link text-blue-400"
                href="mailto:contact@any-mate.com"
                type="email"
              >
                contact@any-mate.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex flex-col gap-4">
        <div class="text-xl font-bold">FAQ</div>
        <div
          class="collapse collapse-arrow border border-base-300 bg-base-200"
          tabindex="0"
        >
          <div class="collapse-title items-center text-base flex">
            {{ t("Buttons.deleteAccount") }}
          </div>
          <div
            class="collapse-content prose"
            v-html="t('contactUs.deleteAccountInstruction')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
